module.exports = __webpack_public_path__ + "static/canales-4168b11801209e68305333809282eb62.png";